import { render, staticRenderFns } from "./BulletinFileComponent.vue?vue&type=template&id=61b72ac6&scoped=true&"
import script from "./BulletinFileComponent.vue?vue&type=script&lang=js&"
export * from "./BulletinFileComponent.vue?vue&type=script&lang=js&"
import style0 from "./BulletinFileComponent.vue?vue&type=style&index=0&id=61b72ac6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b72ac6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/neta-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61b72ac6')) {
      api.createRecord('61b72ac6', component.options)
    } else {
      api.reload('61b72ac6', component.options)
    }
    module.hot.accept("./BulletinFileComponent.vue?vue&type=template&id=61b72ac6&scoped=true&", function () {
      api.rerender('61b72ac6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/neta/bulletin/BulletinFileComponent.vue"
export default component.exports